import { render, staticRenderFns } from "./mitra-pos.vue?vue&type=template&id=12e6f142&scoped=true"
import script from "./mitra-pos.vue?vue&type=script&lang=js"
export * from "./mitra-pos.vue?vue&type=script&lang=js"
import style0 from "./mitra-pos.vue?vue&type=style&index=0&id=12e6f142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e6f142",
  null
  
)

export default component.exports